import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput, FIELD_TYPES, ActivityTableProperties } from 'src/api/process-module';

interface ActivityTableFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const ActivityTableField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: ActivityTableFieldProps) => {
  const properties = field.properties as ActivityTableProperties;

  return (
    <>
      <TextField
        fullWidth
        label="Table Configuration"
        value={properties?.tableConfig || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            properties: {
              ...properties,
              type: FIELD_TYPES.ACTIVITY_TABLE,
              tableConfig: e.target.value,
            } as ActivityTableProperties,
          })
        }
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter table configuration in JSON format"
      />
    </>
  );
};
